import { Link } from "gatsby"
import React, { useState } from "react"
import styled from "styled-components"
import LinkedButton from "./buttons/LinkedButton"
import { MenuButton } from "./buttons/MenuButton"

const MenuLinks = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100vh;
  width: 100%;
  background: #003554;
  position: absolute;
  top: 0;
  right: 0;
  z-index: -1;
  transition: transform 300ms;
  transform: ${({ isOpen }) =>
    isOpen ? "translateY(0)" : "translateY(-100%)"};
`

export default function Navbar() {
  const [isOpen, setOpen] = useState(false)
  const menuButtonStyle = {
    padding: "0.5em 0",
    marginLeft: "1em",
  }

  const NavLinks = () => (
    <div className="link-container">
      <Link className="link" to="/introduction">
        Our Story
      </Link>
      <Link className="link" to="/projects">
        Our Work
      </Link>
      <Link className="link" to="/courses">
        Courses
      </Link>
      <Link className="link" to="/about">
        About Us
      </Link>
      <Link className="link" to="/team">
        Team
      </Link>
      <Link className="link" to="/volunteer">
        Get Involved
      </Link>
      <Link className="link" to="https://nenathambaraforum.net/">
        Forum
      </Link>
    </div>
  )

  return (
    <nav>
      <Link to="/">
        <h1>NENATHAMBARA</h1>
      </Link>
      <div className="link-mode">
        <NavLinks />

        <Link to="/donate">
          <button className="button-filled">Donate</button>
        </Link>
      </div>
      <div className="menu-mode">
        <LinkedButton path="/donate" label="Donate" filled={true} />
        <MenuButton
          isOpen={isOpen}
          onClick={() => setOpen(!isOpen)}
          strokeWidth="2"
          color="#ffffff"
          transition={{ ease: "easeOut", duration: 0.2 }}
          style={menuButtonStyle}
        />
        <MenuLinks isOpen={isOpen}>
          <NavLinks />
        </MenuLinks>
      </div>
    </nav>
  )
}
